export default __webpack_public_path__ + "static/Templating-5fc837e60dafb163c824ed6684fc7b0c.png";